import SvgComponent from './SvgComponent';

export default SvgComponent;
